import { Link } from "react-router-dom";
import akinLogo from "../../akin.svg";
import { useAuth } from "../hooks/useAuth";
import { LanguageSwitcher } from "./LanguageSwitcher";

function getInitials(name: string | null): string {
	if (!name) return "?";
	return name
		.trim()
		.split(/\s+/)
		.map((part) => part[0].toUpperCase())
		.slice(0, 2)
		.join("");
}

export function AppHeader() {
	const { name } = useAuth();

	return (
		<header className="sticky top-0 z-10 w-full border-b border-ink/10 bg-cream">
			<div className="max-w-2xl mx-auto px-6 py-4 flex items-center justify-between">
				<Link to="/home">
					<img src={akinLogo} alt="Akin" className="h-7 w-auto" />
				</Link>
				<div className="flex items-center gap-4">
					<LanguageSwitcher />
					<Link
						to="/profile"
						className="w-9 h-9 rounded-full bg-ink flex items-center justify-center hover:opacity-80 transition-opacity"
						title={name ?? "Profile"}
					>
						<span className="font-ui text-xs text-cream tracking-wider leading-none">
							{getInitials(name)}
						</span>
					</Link>
				</div>
			</div>
		</header>
	);
}
